import * as React from "react";
import styled from "styled-components";

import { Search as SearchIcon } from "../../Svg/Search";
import { PersonOutline as PersonOutlineIcon } from "../../Svg/PersonOutline";
import { BREAK_POINTS, TEXT } from "../../../consts/style";
import { BorderedNavLink } from "../NavLink";
import { LINKS } from "../../../consts/links";
import { HelpOutlineIcon } from "../../Svg/HelpOutline";
import { ButtonAction } from "../../Button";
import { PhoneNoPhone } from "../../PhoneNoPhone/PhoneNoPhone";
import { TRACKING_CODES } from "../../../consts/trackingCodes";

const AccountNavContainer = styled.div`
  display: flex;
  a.active,
  a:hover span {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const MyAccountLink = styled(BorderedNavLink)`
  cursor: pointer;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    height: 48px;
    padding: 14px 20px;
    > svg {
      right: 10px;
    }
  }
  border-right: 0;
`;

const MyAccountLinkLogin = MyAccountLink.extend`
  > svg {
    fill: ${TEXT.LINK.HOVER};
  }
  > span {
    color: ${TEXT.LINK.HOVER};
  }

  &:hover {
    > svg {
      fill: ${TEXT.LINK.ACTIVE};
    }
    > span {
      color: ${TEXT.LINK.ACTIVE};
    }
  }
`;

const IconLink = styled(BorderedNavLink)`
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    height: 48px;
    padding: 14px 20px;
    > svg {
      right: 5px;
      top: 0px;
    }
  }
`;

const IconLinkBoardLeft = styled(IconLink)`
  @media (max-width: ${BREAK_POINTS.MAX.LG}) {
    border-left: 1px solid #e3e3e3;
  }
`;

export interface IAnchor {
  href?: string;
  text?: string;
}

export const AccountNav = (props: IAnchor) => (
  <AccountNavContainer>
    {props.href &&
      props.text && (
        <PhoneNoPhone
          width={BREAK_POINTS.MIN.LG}
          phone={null}
          noPhone={
            <ButtonAction
              href={props.href}
              tracking={TRACKING_CODES.SEE_OUR_PLANS}
              small
            >
              {props.text}
            </ButtonAction>
          }
        />
      )}
    <IconLinkBoardLeft
      href={LINKS.HEADER.HELP_AND_SUPPORT}
      tracking={TRACKING_CODES.HELP}
    >
      <HelpOutlineIcon />
      <span>Help</span>
    </IconLinkBoardLeft>
    <IconLink href={LINKS.HEADER.SEARCH} tracking={TRACKING_CODES.SEARCH}>
      <SearchIcon />
      <span>Search</span>
    </IconLink>
    <MyAccountLinkLogin
      href={LINKS.HEADER.LOGIN}
      tracking={TRACKING_CODES.LOGIN}
    >
      <PersonOutlineIcon />
      <span>Log in</span>
    </MyAccountLinkLogin>
  </AccountNavContainer>
);
